export default {
    yes: "Yes",
    no: "No",
    ok: "Ok",
    cancel: "Cancel",
    validate: "Validate",
    requiredMessage: "Please enter a value",
    outputTextNoValue: " ",
    numericMessage: "Please enter a numeric value",
    decimalMessage: "Please enter a decimal value",
    dateMessage: "Please enter valid date",
    eMailMessage: "Please enter valid email",
    tableColumnsSelectedText: "columns selected",
    tableAllColumnsSelectedText: "All selected",
    tableNoDataText: "No Data",
    dialogTitleAttention: "Attention!",
    dialogTitleInformation: "Information!",
    preloaderText: "Loading...",
    preventPasteHint: "You should manually type the data. Paste option is not accepted.",
    flowCancelFlowMessage: "All your progress will be lost. Are you sure you want to leave?",
    serverErrorTitle: "Attention!",
    serverErrorMessage: "The application encountered a problem.",

    fileUploadPlaceholder: "upload file",
    fileUploadTitle: "Drag & Drop",

    cancelFlowFailure: "Flow cancellation failed!",
    requestFlowFailure: "Failed to request business activity!",
    endFlowError: "Error processing the business activity!",
    stepPostFailure: "Failed to process step!",
    flowFailure: "Failed load business process!",
    stepDataFailure: "Failed to load step data!",
    defaultValidationMessage: "Values entered are invalid. Please modify your entry.",

    modalAcceptLabel: "OK",
    modalCloseLabel: "Cancel",
    errorGroupLabel: "Blocking Messages",
    successGroupLabel: "Success",
    warningGroupLabel: "Warnings",
    infoGroupLabel: "Information",
    neutralGroupLabel: "Neutral",
    collapsedHintGroupLabel: "Show details",

    renderErrorMessage: "Something went wrong.",

    error: "Error",
    warning: "Warning",

    unsavedChanges: "Changes that you made may not be saved.",
    loadDashboardFailure: "Failed to load dashboard",
    enterValidInfo: "Please enter valid information",
    completeFlowFailure: "Failed to complete business process!",
    stepConfigFailure: "Failed to load step ui config",

    googleMapErrorMessage: "Location not found",
    beforeExitFlowMessage:
        "By continuing, all data already entered will be saved and you can access it later. Are you sure you want to leave?"
};
